import CityPageTemplate from "../city-template/CityPageTemplate";
import { pontiacConfig } from "./data";

export default function PontiacPage() {
  return <CityPageTemplate config={pontiacConfig} />;
}